import { customAxios } from "./api";

export const getShop = async () => {
  try {
    const response = await customAxios.get(`/public/shop/${window.runtimeConfig.SHOP_ID}`);
    // console.log(response);
    if( response.status === 200 )
      return response.data.data;
    
  } catch(error) {
    console.log(error);
  }
  return [];
}

export const getItems = async () => {
  try {
    const response = await customAxios.get(`/public/shop/${window.runtimeConfig.SHOP_ID}/products`);
    // console.log(response);
    if( response.status === 200 )
      return response.data.data;
    
  } catch(error) {
    console.log(error);
  }
  return [];
}

export const getItem = async (id) => {
  try {
    const response = await customAxios.get(`/public/shop/${window.runtimeConfig.SHOP_ID}/product/${id}`);
    // console.log(response);
    if( response.status === 200 )
      return response.data.data;
    
  } catch(error) {
    console.log(error);
  }
  return [];
}

export const getSubItems = async (id) => {
  try {
    const response = await customAxios.get(`/public/shop/${window.runtimeConfig.SHOP_ID}/subproducts/${id}`);
    // console.log(response);
    if( response.status === 200 )
      return response.data.data;
    
  } catch(error) {
    console.log(error);
  }
  return [];
}

export const getPromo = async (id) => {
  try {
    const response = await customAxios.get(`/public/shop/${window.runtimeConfig.SHOP_ID}/promo/${id}`);
    if( response.status === 200 )
      return response.data.data;
    
  } catch(error) {
    console.log(error);
  }
  return [];
}

export const createOrder = async (data, extra, total, type) => {
  try {
    const response = await customAxios.post(`/public/shop/${window.runtimeConfig.SHOP_ID}/order`, {
      data: JSON.stringify(data),
      extra: JSON.stringify(extra),
      total: total,
      type: type,
    });
    // console.log(response);
    if( response.status === 200 )
      return true;
    
  } catch(error) {
    console.log(error);
  }
  return false;
}
